import {
  PlaylistTypesListItem,
  Release,
  ReleaseType,
  SoundCloudRelease,
  TuneCoreRelease,
} from 'types/releases';
import { Link } from 'types/api.types';

interface GetReleaseUIStateProps {
  release?: Release;
  releaseExportLink?: Link;
  playlistTypes: PlaylistTypesListItem[];
}

export const getReleaseUIState = ({
  release,
  releaseExportLink,
  playlistTypes,
}: GetReleaseUIStateProps) => {
  const renderSingleTrackBtn =
    release?.type === ReleaseType.SOUNDCLOUD &&
    (release as SoundCloudRelease)?.versions?.length === 1;
  const renderMultiTrackBtn =
    release?.type === ReleaseType.SOUNDCLOUD &&
    (release as SoundCloudRelease)?.versions?.length > 1;
  const renderTuneCoreBtn =
    release?.type === ReleaseType.TUNECORE &&
    (release as TuneCoreRelease).versions.length > 0;

  const disableSingletrack = !(
    (release as SoundCloudRelease)?.isReadyForExportReason === 'Ready' &&
    releaseExportLink
  );
  const disableMultitrack = !(
    (release as SoundCloudRelease)?.isReadyForExportReason === 'Ready' &&
    playlistTypes.length > 0 &&
    releaseExportLink
  );

  const disableTuneCoreBtn =
    !(
      (release as TuneCoreRelease)?.isReadyForExportReason === 'Ready' &&
      releaseExportLink
    ) ||
    !release?._links?.exportRelease ||
    (release as TuneCoreRelease)?.latestExport?.status === 'PROCESSING' ||
    Boolean(
      (release as TuneCoreRelease)?.latestExport?.tuneCore?.callbackResponse
        ?.tuneCoreReleaseUrl
    );

  return {
    renderSingleTrackBtn,
    renderMultiTrackBtn,
    renderTuneCoreBtn,
    disableSingletrack,
    disableMultitrack,
    disableTuneCoreBtn,
  };
};
